export default __webpack_public_path__ + "static/media/30_Fs.66bdeda8.svg";